import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as classes from './index.module.css';
import AnimatedGrid from '@components/AnimatedGrid';

const D_COLS_BASE = 16;
const M_COLS_BASE = 6;
const PADDING_CELLS = 2; // +2 for width, +2 for height

const getAspectRows = (width, height, baseCols) => {
    if (!width || !height) return baseCols;
    const ratio = width / height;
    const rows = Math.ceil(baseCols / ratio);
    return Math.max(rows, 1);
};

const Quote = ({ text }) => {
    const contentRef = useRef(null);

    const [gridDimensions, setGridDimensions] = useState({
        dCols: D_COLS_BASE + PADDING_CELLS,
        dRows: 6 + PADDING_CELLS,
        mCols: M_COLS_BASE + PADDING_CELLS,
        mRows: 10 + PADDING_CELLS,
    });

    useEffect(() => {
        const element = contentRef.current;
        if (!element) return;

        const updateDimensions = () => {
            const { width, height } = element.getBoundingClientRect();
            if (!width || !height) return;

            const dRowsCalculated = getAspectRows(width, height, D_COLS_BASE);
            const mRowsCalculated = getAspectRows(width, height, M_COLS_BASE);

            setGridDimensions({
                dCols: D_COLS_BASE + PADDING_CELLS,
                dRows: dRowsCalculated + PADDING_CELLS,
                mCols: M_COLS_BASE + PADDING_CELLS,
                mRows: mRowsCalculated + PADDING_CELLS,
            });
        };

        const resizeObserver = new ResizeObserver(() => {
            updateDimensions();
        });

        resizeObserver.observe(element);
        updateDimensions();

        return () => resizeObserver.disconnect();
    }, []);

    const { dCols, dRows, mCols, mRows } = gridDimensions;

    const dataSquares = {
        dCells: [
            {
                id: `1-${dCols -1}`,
                color: 'orange',
            },
            {
                id: `2-${dCols}`,
                color: 'blueLight',
            },
        ],
        mCells: [
            {
                id: `1-${mCols -1}`,
                color: 'orange',
            },
            {
                id: `2-${mCols}`,
                color: 'blueLight',
            },
        ],
    };

    return (
        <div
            className={classes.root}
            style={{
                '--dAspect': `${dCols} / ${dRows}`,
                '--mAspect': `${mCols} / ${mRows}`,
            }}
        >
            <div className={classes.imageContainer}>
                <AnimatedGrid
                    dCells={dataSquares.dCells}
                    mCells={dataSquares.mCells}
                    dCols={dCols}
                    dRows={dRows}
                    mCols={mCols}
                    mRows={mRows}
                />
            </div>
            <div className={classes.cont}>
                <div ref={contentRef} className={classes.contentContainer}>
                    <span className={classes.startQuote}>“</span>
                    <blockquote className={classes.titleContainer}>
                        {text}
                    </blockquote>
                </div>
            </div>
        </div>
    );
};

Quote.propTypes = {
    video: PropTypes.object,
    text: PropTypes.node,
};

export default Quote;